import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatPercent } from '@athena/i18n';
import { cn } from '../../lib/cn.js';
import { useLanguage, useTranslate } from '../../lib/i18n.js';
/**
 * One finished attempt, in a list of them.
 *
 * This is the treatment the history screen had already arrived at, lifted out
 * rather than invented: title and date on the left, the score in tabular
 * figures on the right, and room at the end for a way in or a reason there
 * isn't one.
 *
 * It exists because the student's recent results were building the same row a
 * second way — a bordered card with a whole `ScoreIndicator` inside it, so
 * every row was a card within a card, two hairlines and two paddings deep,
 * with up to four 120px rings stacked down the page. `ScoreIndicator` is the
 * single summary of one finished attempt, which is what the results screen
 * uses it for; it was never a list unit.
 *
 * The score is figures rather than a ring for the same reason: in a list, the
 * comparison down the column is the point, and tabular digits line up where
 * four rings cannot.
 *
 * Flat, with no border of its own. The parent `ul` owns the dividers between
 * rows (`divide-y divide-border`), so a list never becomes a stack of boxes.
 */
export function ResultRow({ title, detail, percent, correctCount, questionCount, trailing, className, }) {
    const t = useTranslate();
    const language = useLanguage();
    return (_jsxs("div", { className: cn('flex min-w-0 flex-wrap items-center justify-between gap-4 py-4', className), children: [_jsxs("div", { className: "flex w-full min-w-0 flex-col gap-1 wrap-anywhere sm:w-auto sm:flex-1", children: [_jsx("span", { className: "text-h4 font-semibold text-text", children: title }), _jsx("span", { className: "text-body-sm text-text-secondary", children: detail })] }), _jsxs("div", { className: "ml-auto flex min-w-0 max-w-full flex-col items-end gap-2 sm:flex-row sm:items-center sm:gap-4", children: [_jsxs("span", { className: "flex flex-col items-end", children: [_jsx("span", { className: "text-h3 font-bold tabular-nums text-text", children: formatPercent(percent, language) }), _jsx("span", { className: "text-body-sm tabular-nums text-text-secondary", children: t('common.ofTotal', [correctCount, questionCount]) })] }), trailing ? (_jsx("div", { className: "max-w-40 text-right wrap-anywhere sm:w-40 sm:shrink-0", children: trailing })) : null] })] }));
}
//# sourceMappingURL=ResultRow.js.map